import {Component} from "react";
import {
    Button,
    Layout,
    Space,
    Table,
    Spin,
    Form,
    Row,
    Col,
    Input,
    FormInstance, DatePicker
} from "antd";
import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavFooter from "../../components/NavFooter";

import '../css/main.less'
import React from "react";
import AxiosUtil from "../../utils/AxiosUtil";
import NavBreadcrumb from "../../components/NavBreadcrumb";
import TaskList from "./components/TaskList";
import moment from "moment";
import { SearchOutlined, FilePdfOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;
const {Content} = Layout;

interface IProps {
}

export default class AiReportCheck extends Component<IProps> {
    queryRef = React.createRef<FormInstance>();

    taskListRef: TaskList | undefined;
    onTaskListRef = (ref: any) => {
        this.taskListRef = ref;
    }

    state = {
        mainData: [],
        mainTotal: 0,
        showLoading: false,
        pageIndex:1
    }

    componentDidMount() {
        //组件加载完成后触发
        this.loadMainData();
    }

    render() {
        const crumb = [
            {name: '智能研报'},
            {name: '研报结果检查'},
        ];
        const columns = [
            {title: "ID", dataIndex: "id",},
            {title: "股票代码", dataIndex: "symbol",},
            {title: "股票名称", dataIndex: "security_name",},
            {title: "研报日期", dataIndex: "publish_date",},
            {title: "完成日期", dataIndex: "create_time",},
            {title: "查看", dataIndex: "_",
                align: 'center' as 'center',
                render: (text: string, row: any) => {
                    return (
                        <a href={`/#/ai-report/reportview/${row.symbol}`} target={"_blank"} rel="noreferrer" ><FilePdfOutlined /> 查看研报</a>
                    )
                }},
        ];
        return (
            <Layout>
                <NavHeader />
                <Content className={"main-body"}>
                    <Layout>
                        <SiderMenuMain/>
                        <Content className={'main-content'}>
                            <NavBreadcrumb itemList={crumb}/>

                            <Spin tip="Loading..." size="large" spinning={this.state.showLoading}>

                                <div id="" style={{marginTop: 15}}>
                                    <Form name="AiReport_Form"
                                          layout="horizontal"
                                          onFinish={this.loadFormData}
                                          ref={this.queryRef}
                                          colon={false}
                                          className={'query_form'}>
                                        <Row gutter={[40, 0]}>
                                            <Col span={7}>
                                                <Form.Item name={'taskTime'} label={'日期'}  initialValue={[moment().add(-7,"day"), moment()]}>
                                                    <RangePicker format={"YYYY-MM-DD"}/>
                                                </Form.Item>
                                            </Col>
                                            <Col span={4}>
                                                <Form.Item name={'searchText'} label={'股票'}  initialValue={''}>
                                                    <Input allowClear={true}></Input>
                                                </Form.Item>
                                            </Col>
                                            <Col span={5}>
                                                <Form.Item >
                                                    <Space size={16}>
                                                        <Button type="primary" htmlType="submit"><SearchOutlined/>查询</Button>
                                                    </Space>
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                            </Col>

                                            <Col span={4}>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                                <div id="mainTableDiv">
                                    <Table key="t"
                                           // size="small"
                                           rowKey="id"
                                           columns={columns}
                                           dataSource={this.state.mainData}
                                           pagination={{
                                               pageSize:10,
                                               onChange: this.loadPageChange,
                                               total: this.state.mainTotal,
                                               showSizeChanger: false,
                                               size:"default"
                                           }}
                                    />
                                </div>
                            </Spin>
                        </Content>
                    </Layout>
                </Content>
                <NavFooter/>
            </Layout>


        );
    }
    loadPageChange= (page:number, pageSize?:number) => {
        this.loadMainData(page);
    }
    loadFormData = () => {
        this.loadMainData();
    }
    loadMainData = (pageIndex?: number) => {
        this.setState({showLoading: true});
        if (pageIndex)
            this.setState({pageIndex: pageIndex});
        else
            pageIndex = this.state.pageIndex;

        let values = this.queryRef.current?.getFieldsValue();
        console.log(values);
        let queryParam = {
            pageIndex: pageIndex,
            pageSize: 10,
            publish_beginTime: values.taskTime[0].format("YYYY-MM-DD"),
            publish_endTime: values.taskTime[1].format("YYYY-MM-DD"),
            searchText: values.searchText
        }
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({
                    mainData: dat.logDOList,
                    mainTotal: dat.total
                })
            }
            this.setState({showLoading: false});
        }
        AxiosUtil.AxiosRequest('/api/pdf/getPdfList', queryParam, callback);
    }
}